import { CaseStatuses } from "./constants";
import { useGetCases } from "./useGetCases";

export function useGetCaseHistoryPageData() {
  const { data: bookedOpenCasesData, isLoading: isLoadingBookedOpenCases } = useGetCases({
    filter: {
      status: CaseStatuses.OPEN,
      booked: "true",
    },
  });

  const { data: bookedClosedCasesData, isLoading: isLoadingBookedClosedCases } = useGetCases({
    filter: {
      status: CaseStatuses.CLOSED,
      booked: "true",
    },
  });

  const isLoading = isLoadingBookedOpenCases || isLoadingBookedClosedCases;

  return {
    bookedOpenCases: bookedOpenCasesData?.data ?? [],
    bookedClosedCases: bookedClosedCasesData?.data ?? [],
    isLoading,
  };
}
